<script>
import {
    name,
    sex,
    age,
    residence,
    visitor,
    visitPurpose,
    visitCompany,
    visitAddress,
    idNumber,
    department,
    temp,
    soreThroat,
    bodyPains,
    headache,
    fever,
    covidContact,
    supsectContact,
    travelAbroad,
    travelCity,
    triage,
    triageDesc,
    time
} from '../store.js'
import { onMount } from 'svelte';
import htmlToImage from 'html-to-image';
let personQrcode, symptomQrcode, visitQrcode, isVisitor, showTemp
if ($visitor === 'YES') {
    isVisitor = true
} else {
    isVisitor = false
}

if (process.env.SKIP_TEMP !== 'true' && !isVisitor) {
    showTemp = true
} else {
    showTemp = false
}

let personInfo = `NAME: ${$name}
SEX: ${$sex}
AGE: ${$age}
RESIDENCE: ${$residence}`
if (!isVisitor) {
personInfo += `
ID NUMBER: ${$idNumber}
DEPARTMENT: ${$department}`
}
personInfo += `
CREATED: ${$time}`

let visitInfo = `VISITOR: ${$visitor}
PURPOSE: ${$visitPurpose}
COMPANY: ${$visitCompany}
ADDRESS: ${$visitAddress}`

let region = process.env.REGION
let symptomInfo = ""
if (showTemp) {
symptomInfo = `TEMPERATURE: ${$temp}
`
}
symptomInfo += `SORE THROAT: ${$soreThroat}
BODY PAINS: ${$bodyPains}
HEADACHE: ${$headache}
FEVER: ${$fever}
COVID CONTACT: ${$covidContact}
SUSPECT CONTACT: ${$supsectContact}
TRAVEL ABROAD: ${$travelAbroad}
TRAVEL IN ${region}: ${$travelCity}`

onMount(() => {
    let script = document.createElement('script');
    script.src = "https://cdn.rawgit.com/davidshimjs/qrcodejs/gh-pages/qrcode.min.js"
    document.head.append(script);

    script.onload = function() {
        personQrcode = new QRCode("personInfo", {
            text: personInfo,
            width: 200,
            height: 200,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.M
        });	
        symptomQrcode = new QRCode("symptomInfo", {
            text: symptomInfo,
            width: 200,
            height: 200,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.M
        });
        if (isVisitor) {
            visitQrcode = new QRCode("visitInfo", {
                text: visitInfo,
                width: 200,
                height: 200,
                colorDark : "#000000",
                colorLight : "#ffffff",
                correctLevel : QRCode.CorrectLevel.M
            });
        }
    };				
});

let imgLoading = false
function saveImg() {
    imgLoading = true
    htmlToImage.toJpeg(document.getElementById('qrImage'), { quality: 0.95 })
        .then(function (dataUrl) {
            var link = document.createElement('a');
            link.download = `healthdec.jpeg`;
            link.href = dataUrl;
            link.click();
            imgLoading = false
        });
}

let emails = process.env.EMAILS, mailto
if (emails) {
emails = emails.split(' ')
let body = `PERSON INFO
${personInfo}

SYMPTOMS
${symptomInfo}`
if (isVisitor === true) {
body += `

VISITOR INFO
${visitInfo}`
}
body = encodeURI(body)

let date = new Date($time)
let subjDate = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + date.getFullYear()
let subject = encodeURI(`${subjDate} - ${$name} - HEALTH DEC`)

mailto = "mailto:"
function mailtoGen(item, index) {
    mailto += `,${item}`
}
emails.forEach(mailtoGen)
mailto += `?subject=${subject}&body=${body}`
}
</script>

<main>
<div class="jumbo">
    <h1>Your Health Declaration is ready</h1>
    {#if imgLoading === false}
    <a class="btn btn-primary" on:click={() => saveImg()}>
        <span class="e">Download</span><br>
        <span>Save as Picture</span>
    </a>
    {/if}
    {#if imgLoading === true}
    Please wait...
    {/if}
    {#if emails}
    <a class="btn" href={mailto}>
        <span class="e">Send Health Dec</span><br>
        <span class="f">Send your results to your company point person</span>
    </a>
    {/if}
</div>

<div id="qrImage">
<div class="card">
    <p class="head">Timestamp</p>
    <p class="text-primary">{$time}</p>
</div>

{#if $triage !== ''}
<div class="card">
    <p class="head">Health Alert</p>
    <h2 class="text-primary">{$triage}</h2>
    <p>{$triageDesc}</p>
</div>
{/if}

<div class="card">
    <p class="head">Person Info</p>
    <div id="personInfo"></div>
    <p>Name: {$name}</p>
    <p>Age: {$age}</p>
    <p>Sex: {$sex}</p>
    <p>Residence: {$residence}</p>
    {#if !isVisitor}
    <p>ID Number: {$idNumber}</p>
    <p>Department: {$department}</p>
    {/if}
</div>

{#if isVisitor === true}
<div class="card">
    <p class="head">Visit Info</p>
    <div id="visitInfo"></div>
    <p>Purpose of Visit: {$visitPurpose}</p>
    <p>Company: {$visitCompany}</p>
    <p>Address: {$visitAddress}</p>
</div>
{/if}

<div class="card">
    <p class="head">Symptom Info</p>
    <div id="symptomInfo"></div>
    {#if showTemp}
    <p>Temperature: {$temp}</p>
    {/if}
    <p>Body Pains: {$bodyPains}</p>
    <p>Headache: {$headache}</p>
    <p>Fever: {$fever}</p>
    <p>Contact with known COVID case: {$covidContact}</p>
    <p>Contact with person/s with symptoms: {$supsectContact}</p>
    <p>Travelled Abroad: {$travelAbroad}</p>
    <p>Travel within {region}: {$travelCity}</p>
</div>
</div>
</main>

<style>
#qrImage {
    background: #ffffff;
    padding-top: 24px;
    padding-bottom: 24px;
}

.card {
    padding: 24px;
    margin: 18px;
    border: solid 1px #dfdfdf;
}

.jumbo {
    margin: 18px;
    margin-top: 64px;
    margin-bottom: 0;
}

.head {
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #333333;
    font-weight: 700;
}

.btn {
    border-color: var(--primary-color);
    width: calc(100% - 26px);
}

.text-primary {
    color: var(--primary-color);
}

.hide {
    display: none;
}
</style>